import { render, staticRenderFns } from "./TitleTextWithIcon.vue?vue&type=template&id=181f63fe&scoped=true"
import script from "./TitleTextWithIcon.vue?vue&type=script&lang=ts"
export * from "./TitleTextWithIcon.vue?vue&type=script&lang=ts"
import style0 from "./TitleTextWithIcon.vue?vue&type=style&index=0&id=181f63fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181f63fe",
  null
  
)

export default component.exports